import styled from "@emotion/styled";
import { Heading, Text } from "@otrium/atoms";
import FlagRound from "src/atoms/FlagRound";
import { ChevronRight } from "src/icons/ChevronRight";
import { Expandable as ExpandableAtom } from "src/atoms/Expandable";
import { Menu as MenuAtom } from "src/atoms/Menu";
import BaseButton from "src/atoms/Button/BaseButton";
import { hideScrollbar } from "src/scrollbar";

const MenuWrapper = styled.div`
  position: relative;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    &.footer {
      width: 100%;
      padding-bottom: 23px;
      border-bottom: 1px solid
        ${({ theme }) => theme.colors.tone.anthraciteDark};
      margin-bottom: 23px;
    }
  }
`;

const Menu = styled(MenuAtom)`
  display: none;
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`;

const MenuMobile = styled(MenuAtom)`
  display: block;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

const Button = styled(BaseButton)`
  display: flex;
  align-items: center;
  border: none;
  background: none;
  color: ${({ theme }) => theme.colors.tone.white};
  margin-right: -5px;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    &.footer {
      width: 100%;
    }

    width: inherit;
  }
`;

interface DropdownProps {
  isFooter: boolean;
  open?: boolean;
}

const Dropdown = styled(ChevronRight)<DropdownProps>`
  margin-left: auto;
  width: 16px;
  transform: ${({ isFooter }) => (isFooter ? "rotate(0deg)" : "rotate(90deg)")};
  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    transform: rotate(90deg);
    ${({ open, theme }) =>
      open &&
      `
      transform: rotate(-90deg);
      fill: ${theme.colors.tone.white};
    `}
  }
  fill: ${({ theme }) => theme.colors.tone.anthraciteLight};
  transition: all 0.2s ease;
`;

const Flag = styled(FlagRound)`
  width: 20px;
  height: 20px;
`;

const ListTitle = styled(Heading)`
  font-size: 40px;
  line-height: 1.2;
  text-align: center;
  color: ${({ theme }) => theme.colors.tone.black};
  margin-bottom: 40px;
`;

const MenuListContent = styled.div`
  background: ${({ theme }) => theme.colors.tone.white};
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;
`;

const Expandable = styled(ExpandableAtom)`
  z-index: 10000;
  position: absolute;
  width: 320px;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  margin-top: 23px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    left: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    right: -6px;
  }

  &.mask {
    &:after {
      content: "";
      position: absolute;
      width: 100%;
      bottom: 0;
      height: 56px;
      border-radius: 4px;
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0),
        #ffffff
      );
    }
  }
`;

const LocaleName = styled(Text)`
  display: none;
  font-size: ${({ theme }) => theme.fontSizes.fontSize12};
  line-height: 1.43;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  margin-left: ${({ theme }) => theme.space.space4};

  &.footer {
    display: block;
  }
`;

const MobileListWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: ${({ theme }) => theme.zIndex.overlay};
  background-color: ${({ theme }) => theme.colors.tone.white};
  overflow-y: auto;
  ${hideScrollbar}
`;

export {
  MenuWrapper,
  Menu,
  Button,
  Flag,
  Dropdown,
  MenuMobile,
  ListTitle,
  MenuListContent,
  Expandable,
  LocaleName,
  MobileListWrapper,
};
